export default function LoadSpinner({loading}) {
  return (
    <div className={`load-spinner ${loading ? '' : 'fade-out'}`}>
      <div className="load-spinner-inner">
        <div className="spinner">
          <div className="dot1"></div>
          <div className="dot2"></div>
        </div>
      </div>
    </div>
  );
}
